<cer-form #form [panes]="panes" (commmand)="onCommand($event)">
  <ng-template #mainTemplate>
    <cer-grid #grid [formView]="formView" [id]="formView?.id" [viewMetadata]="viewMetadata"
      [fieldMetadata]="fieldMetadata" [toolbarCommands]="toolbarCommands" [contextMenuCommands]="contextMenuCommands"
      [keyboardShortcuts]="keyboardShortcuts"
      (commmand)="onCommand($event)"></cer-grid>
  </ng-template>
</cer-form>